import { MjmlColumn, MjmlDivider, MjmlSection } from "@faire/mjml-react";
import { Section } from "@redotech/redo-model/email-builder";
import { memo } from "react";

export type LineState = Section.Line;

export const EmailLine = memo(function EmailLine(props: LineState) {
  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      <MjmlColumn>
        <MjmlDivider borderColor={props.color} borderWidth={2} />
      </MjmlColumn>
    </MjmlSection>
  );
});
